import { v_DispatchAttachmentBus } from "./v_DispatchAttachmentBus";
import { v_DispatchNoteBus } from "./v_DispatchNoteBus";
import { BaseBus } from "./BaseBus";

export class v_DispatchBus extends BaseBus
{
    dispatchId: any;
    dispatchNumber: string;
    ponumber: string;
    wonumber: string;
    receivedDateTime: Date;
    notToExceed: number;
    whoCalledName: string;
    needsQuote: boolean;
    dispatchStatusName: string;
    dispatchStatusCategory: string;
    customerName: string;
    locationName: string;
    color: number;
    priorityColor: string;
    priorityName: string;
    receivedByLastName: string;
    dispatchReason: string;
    quoteNumber: string;
    quickSearchKey: string;
    invoiceNumber: string;
    addressLine1: string;
    addressLine2: string;
    city: string;
    stateProvince: string;
    postalCode: string;
    assignedDate: Date;
    startDate: Date;
    finalBillingDt: Date;
    hasOrderItem: boolean;
    accountClassId: any;
    pOOverrideUserId: any;
    invoiceAmt: number;
    relatedJobTypeId: any;
    jobWarrantyEndDate: Date
    isConstruction: boolean;
    isOpen: boolean;
    isCurrent: boolean ;
    isPartsRelated: boolean ;
    isCanceledMerged: boolean;
    highPriority: boolean;
    isActiveLocation: boolean;
    dispatchAttachments: v_DispatchAttachmentBus[];
    dispatchNotes: v_DispatchNoteBus[];
    dispatchAttachmentDetails: v_DispatchAttachmentBus[];
    customerId: any;
    locationId: any;
    dispatchStatusId: any;
    priorityId: any;
    receivedById: any;
    invoiceId: any;
    quoteId: any;
    pmPrice: number;
    onCallRegionName: number;
    discreetBillerId: any;
    defaultSubmitterId: any;
    invoiceEstimate: number;
    costAmt: number;
    acctMgrName: string;
    purchaserName: string;
    prioritySubTypeName: string;

  public get hasAttachments(): boolean {
    return this.dispatchAttachments != undefined && this.dispatchAttachments != null && this.dispatchAttachments.length > 0; 
  }
  public get hasPhotos(): boolean {
    return this.dispatchAttachmentDetails != undefined && this.dispatchAttachmentDetails != null && this.dispatchAttachmentDetails.length > 0;
  }

}
